<template>
  <div class="careers">
    <!-- Hero Section -->
    <div class="careers-hero">
      <div class="hero-overlay">
        <div class="container">
          <h1>Join Our Team</h1>
          <p>Be part of a team that's building the future of technology</p>
        </div>
      </div>
      <img src="@/assets/images/image3.png" alt="Careers at our company" class="hero-image">
    </div>

    <!-- Open Positions -->
    <div class="container">
      <section class="open-positions">
        <h2>Open Positions</h2>
        <div class="positions-grid">
          <!-- Position Card 1 -->
          <div class="position-card">
            <h3>Frontend Developer</h3>
            <div class="position-meta">
              <span class="location"><i class="fas fa-map-marker-alt"></i> Hybrid</span>
              <span class="type"><i class="fas fa-briefcase"></i> Full-time</span>
            </div>
            <p>We're looking for an experienced Frontend Developer to join our team and help us build amazing user experiences.</p>
            <router-link to="/careers/frontend-developer" class="btn-apply">View Details</router-link>
          </div>

          <!-- Position Card 2 -->
          <div class="position-card">
            <h3>UX/UI Designer</h3>
            <div class="position-meta">
              <span class="location"><i class="fas fa-map-marker-alt"></i> Hybrid</span>
              <span class="type"><i class="fas fa-briefcase"></i> Full-time</span>
            </div>
            <p>Join our design team to create beautiful and intuitive user interfaces for our products.</p>
            <router-link to="/careers/ux-designer" class="btn-apply">View Details</router-link>
          </div>

          <!-- Position Card 3 -->
          <div class="position-card">
            <h3>Backend Developer</h3>
            <div class="position-meta">
              <span class="location"><i class="fas fa-map-marker-alt"></i> Hybrid</span>
              <span class="type"><i class="fas fa-briefcase"></i> Full-time</span>
            </div>
            <p>Help us build robust and scalable backend systems that power our applications.</p>
            <router-link to="/careers/backend-developer" class="btn-apply">View Details</router-link>
          </div>
        </div>
      </section>
    </div>

    <!-- CTA Section -->
    <section class="cta">
      <div class="container">
        <div class="cta-social">
          <div class="social-title">Follow us!</div>
          <div class="social-icons">
            <a href="#" aria-label="LinkedIn" class="social-icon" target="_blank" rel="noopener">
              <font-awesome-icon :icon="['fab', 'linkedin-in']" />
            </a>
          </div>
        </div>
        <div class="cta-content">
          <h2 class="expertise-title" style="color: #ffffff; margin-bottom: 2rem; position: relative; display: inline-block;">Ready to join our team?</h2>
          <router-link to="/contact" class="btn btn-white">Apply Now</router-link>
          <div class="cta-footer">
            Copyright &copy; 2025 Advanced Innovatics Solutions | All rights reserved.
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CareersView',
  metaInfo: {
    title: 'Careers - Join Our Team',
    meta: [
      { name: 'description', content: 'Explore career opportunities and join our team of talented professionals.' }
    ]
  }
}
</script>

<style scoped>
.careers {
  padding-bottom: 4rem;
}

/* Hero Section */
.careers-hero {
  position: relative;
  color: white;
  margin-bottom: 2rem;
  height: 50vh;
  min-height: 300px;
  max-height: 600px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.7) 100%);
  display: flex;
  align-items: center;
  z-index: 2;
  padding: 1rem;
}

.hero-image {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.careers-hero .container {
  position: relative;
  z-index: 3;
  text-align: center;
  max-width: 800px;
  padding: 0 1rem;
  width: 100%;
}

.careers-hero h1 {
  font-size: 2rem;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  line-height: 1.2;
  color: #ffffff;
}

.careers-hero p {
  font-size: 1.1rem;
  opacity: 0.9;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  margin: 0 auto;
  max-width: 90%;
}

/* Responsive adjustments */
@media (min-width: 768px) {
  .careers-hero {
    height: 60vh;
  }
  
  .careers-hero h1 {
    font-size: 3rem;
  }
  
  .careers-hero p {
    font-size: 1.5rem;
  }
}

/* Open Positions */
.open-positions {
  margin-bottom: 4rem;
}

.open-positions h2 {
  text-align: center;
  margin-bottom: 2.5rem;
  color: #2c3e50;
  font-size: 2rem;
}

.positions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.position-card {
  background: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.position-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.position-card h3 {
  color: #2c3e50;
  margin-bottom: 0.75rem;
}

.position-meta {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  color: #6b7280;
  font-size: 0.9rem;
}

.position-meta i {
  margin-right: 0.5rem;
  color: #4361ee;
}

.btn-apply {
  display: inline-block;
  margin-top: 1rem;
  padding: 0.5rem 1.5rem;
  background-color: #4361ee;
  color: white;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.btn-apply:hover {
  background-color: #3a56d4;
}

/* Responsive Design */
@media (max-width: 768px) {
  .positions-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .careers-hero {
    padding: 4rem 1rem;
  }
  
  .careers-hero h1 {
    font-size: 1.75rem;
  }
  
  .position-meta {
    flex-direction: column;
    gap: 0.5rem;
  }
}

/* CTA Section */
.cta {
  background: linear-gradient(135deg, #4361ee 0%, #3a0ca3 100%);
  color: white;
  padding: 4rem 0;
  margin-top: 4rem;
}

.cta .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.cta .cta-social {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.5rem;
  text-align: left;
}

.cta .cta-social .social-title {
  font-weight: 700;
  font-size: 1.25rem;
  color: #ffffff;
  margin: 0;
}

.cta .cta-social .social-icons {
  display: flex;
  gap: 1rem;
}

.cta .cta-social .social-icon {
  width: 64px;
  height: 64px;
  border: 3px solid #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 1.5rem;
  text-decoration: none;
  transition: transform 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.cta .cta-social .social-icon:hover {
  background: rgba(255, 255, 255, 0.08);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.cta .cta-content {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 1rem;
  flex-wrap: wrap;
}

.cta .cta-footer {
  width: 100%;
  text-align: left;
  margin-top: 2rem;
  font-size: 0.9rem;
  opacity: 0.8;
  padding-left: 0;
}

.cta .btn-white {
  background: transparent;
  color: #ffffff;
  border: 3px solid #ffffff;
  padding: 0.75rem 2rem;
  border-radius: 50px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  font-size: 1rem;
  display: inline-block;
  cursor: pointer;
  letter-spacing: 0.5px;
}

.cta .btn-white:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .cta .container {
    flex-direction: column;
    text-align: center;
  }
  
  .cta .cta-social {
    flex-direction: column;
    align-items: center;
    margin-bottom: 2rem;
  }
  
  .cta .cta-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
</style>
